"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClickGameDemo = void 0;
var useClickGameDemo_1 = require("./useClickGameDemo");
Object.defineProperty(exports, "useClickGameDemo", { enumerable: true, get: function () { return useClickGameDemo_1.useClickGameDemo; } });
